import { ShowAllTitle } from '@components/atoms/ShowAllTitle/ShowAllTitle';
import { Carousel } from '@components/molecules/Carousel/Carousel';
import { TvCurrentProgram } from '@components/molecules/TvCurrentProgram/TvCurrentProgram';

export const PageContentElementTvmTopics = (element) => {
  if (!element.topicEntries?.topics) return null;
  return (
    <div className="relative pl-4 sm:pl-8 lg:pl-16">
      <section className="space-y-32">
        {element?.topicEntries?.topics.map((topic, index) => (
          <div key={topic.id}>
            <ShowAllTitle title={topic.title} link={topic.title_link} />
            <Carousel key={index} classProps={{ slide: '!h-auto' }}>
              {topic.showtimes.map((showtime) => (
                <TvCurrentProgram
                  classProps={{ root: 'block w-min min-w-72 max-w-full' }}
                  key={showtime.id}
                  primetime={false}
                  channelEntry={showtime}
                  channel={showtime.channel}
                  showDate={true}
                />
              ))}
            </Carousel>
          </div>
        ))}
      </section>
    </div>
  );
};

export default PageContentElementTvmTopics;
